import { changePasswordSchema } from "@/schema";
import { useFormik } from "formik";
import React, { useState } from "react";
import Input from "../Global/Input";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import PrimaryBtn, { SecondaryBtn } from "../Global/Button";
import { useMutation } from "@tanstack/react-query";
import { serverPUT } from "@/utils/HttpFunctions";
import { errorNotfiy, successNotfiy } from "../Global/Toast";

const defaultValues = {
  oldPassword: "",
  newPassword: "",
  confirmPassword: "",
};

export default function ChangePassword({ handleClose }) {
  const [showPassword, setShowPassword] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  const { mutate, isPending } = useMutation({
    mutationFn: (body: any) => serverPUT("/auth/changepassword", body),
    onError: (error) => {
      console.log("🚀 ~ Login ~ error:", error);
      errorNotfiy(error?.message || `Something went wrong`);
    },
    onSuccess: (data) => {
      successNotfiy("Password changed successfully", () => {});
      handleClose();
    },
  });

  const formik = useFormik({
    initialValues: defaultValues,
    validationSchema: changePasswordSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      const body = {
        oldPassword: values.oldPassword,
        newPassword: values.newPassword,
      };
      mutate(body);
    },
  });
  const { values, handleChange, handleSubmit } = formik;
  const handleClickShowPassword = (name) => {
    setShowPassword({ ...showPassword, [name]: !showPassword[name] });
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="space-y-3">
        <div>
          <Input
            label="Old Password"
            value={values.oldPassword}
            placeholder="Enter old password"
            type={showPassword.oldPassword ? "text" : "password"}
            name="oldPassword"
            onChange={handleChange}
            rightIcon={
              showPassword.oldPassword ? (
                <FaRegEye className="text-[#667085]" />
              ) : (
                <FaRegEyeSlash />
              )
            }
            handleIconClick={() => handleClickShowPassword("oldPassword")}
            touched={formik.touched.oldPassword}
            error={formik.errors.oldPassword}
          />
        </div>
        <div>
          <Input
            label="New Password"
            value={values.newPassword}
            placeholder="Enter new password"
            type={showPassword.newPassword ? "text" : "password"}
            name="newPassword"
            onChange={handleChange}
            rightIcon={
              showPassword.newPassword ? (
                <FaRegEye className="text-[#667085]" />
              ) : (
                <FaRegEyeSlash />
              )
            }
            handleIconClick={() => handleClickShowPassword("newPassword")}
            touched={formik.touched.newPassword}
            error={formik.errors.newPassword}
          />
        </div>
        <div>
          <Input
            label="Confirm Password"
            value={values.confirmPassword}
            placeholder="Enter confirm password"
            type={showPassword.confirmPassword ? "text" : "password"}
            name="confirmPassword"
            onChange={handleChange}
            rightIcon={
              showPassword.confirmPassword ? (
                <FaRegEye className="text-[#667085]" />
              ) : (
                <FaRegEyeSlash />
              )
            }
            handleIconClick={() => handleClickShowPassword("confirmPassword")}
            touched={formik.touched.confirmPassword}
            error={formik.errors.confirmPassword}
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-x-2 w-full mt-6">
        <SecondaryBtn text="Cancel" onClick={handleClose} />

        <PrimaryBtn
          text="Save"
          type="submit"
          disabled={isPending}
          loading={isPending}
        />
      </div>
    </form>
  );
}
